import { createAction, props } from '@ngrx/store';

const actionPrefix = '[Dashboard] [Apps]';

const setIsCheckoutAppActive = createAction(
  `${actionPrefix} Set Checkout App Active State`,
  props<{ isCheckoutAppActive: boolean; shopId: number }>(),
);

const setIsSlackWebhookActive = createAction(
  `${actionPrefix} Set Slack Webhook Active State`,
  props<{ isSlackWebhookActive: boolean; shopId: number }>(),
);

const toggleFieldsToActions = {
  isSlackWebhookActive: setIsSlackWebhookActive,
  isCheckoutAppActive: setIsCheckoutAppActive,
};

export { setIsCheckoutAppActive, setIsSlackWebhookActive, toggleFieldsToActions };
